import React from 'react';

import { EmployeeAutomationSendTo } from './employee-automation-send-to';

import { combineWords } from '../../../util/formatters';
import { getApplicationAutomationTiming } from '../../utils/applicant-automation-display-utils';
import { getAlertRecipients } from '../../utils/employee-automation-display-utils';
import { isApplicantAutomation } from '../../utils/is-applicant-automation';

type InputProps = {
  automation: ApplicantAutomation | StartDateTriggeredCommunication;
  toggleEditRecipients: () => void;
};

export const AutomationComponentDetails = (props: InputProps) => {
  const { automation, toggleEditRecipients } = props;
  const alertRecipients = isApplicantAutomation(automation) ? [] : getAlertRecipients(automation);

  return isApplicantAutomation(automation) ? (
    <div className="typo-subtitle u-margin-bottom-md">
      {getApplicationAutomationTiming(automation)}
    </div>
  ) : (
    <div className="u-margin-bottom-md">
      <EmployeeAutomationSendTo automation={automation} />
      {!!alertRecipients.length && (
        <div className="typo-subtitle">
          This alert will be sent to {combineWords(alertRecipients)}.{' '}
          <span role="presentation" className="typo-link" onClick={toggleEditRecipients}>
            Edit recipients
          </span>
        </div>
      )}
    </div>
  );
};
